import { Component, OnInit, OnDestroy, Type, Input } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-sidepane',
  standalone: true,
  imports: [
    CommonModule,
    NgComponentOutlet,
    ButtonModule,
    TooltipModule
  ],
  templateUrl: './sidepane.component.html',
  styleUrls: ['./sidepane.component.scss']
})
export class SidePaneComponent implements OnInit, OnDestroy {
  @Input() defaultPosition: 'left' | 'right' = 'right';

  isVisible = false;
  panelTitle = '';
  dynamicComponent: Type<any> | null = null;
  componentInputs: Record<string, any> = {};
  position: 'left' | 'right' = 'right';

  private destroy$ = new Subject<void>();

  constructor(private layoutService: LayoutService) {}

  // Computed property to check if panel has content
  get hasContent(): boolean {
    return this.dynamicComponent !== null;
  }

  ngOnInit(): void {
    // Set initial position from input
    this.position = this.defaultPosition;

    // Subscribe to panel configuration changes
    this.layoutService.panelConfig
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        this.isVisible = config.visible;
        this.panelTitle = config.title;
        this.dynamicComponent = config.component;
        this.componentInputs = config.inputs || {};
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle(): void {
    this.layoutService.togglePanel();
  }

  close(): void {
    this.layoutService.closePanel();
  }

  getToggleIcon(): string {
    if (this.position === 'right') {
      return this.isVisible ? 'pi pi-angle-right' : 'pi pi-angle-left';
    } else {
      return this.isVisible ? 'pi pi-angle-left' : 'pi pi-angle-right';
    }
  }
}
